import moment from 'moment';
const LoopUpUtilities = (() => {
    try {
        var userDetails = window.atob(localStorage.getItem("userDetails"));
        if (userDetails) {
            userDetails = JSON.parse(userDetails);
        }
    } catch (e) {
        window.location.reload();
    }
    class RAS {
        constructor(obj) {
            //console.log(obj)
            obj.forEach((x) => {
                if (x.type !== "noneditable")
                    this[x.name] = (x.type == "editable") ? parseInt(x.value) : (x.type == "hide") ? (x.name == "ID") ? parseInt(x.value) : x.value : x.value;
                if (x.type === "month-picker")
                    this[x.name] = (x.value === "") ? moment(new Date()).format("YYYY-MM-DD") : moment(x.value).format("YYYY-MM-DD");

            });
        }
    }

    let _match_obj =
    {
        department: "department",
        industry_group: "industry",
        niche_group: "nicheGroups",
        belongsto_group: "rightsGroupNames",
        branch_id: "firmBranches",
        page_id: "pageDetails",
        primary_role: "rolesDetails",
        secondary_role: "rolesDetails",
        title_level: "titleLevelList",
        expertise: "expertise",
        generation_type: "generation_type",
        YearsOfExp: "YearsOfExp",
        LandingPageId: "pageDetails",
        task_locations: "firmBranches"
    }

    let _month_text = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var _rasobjecttype = { ID: "hide", Deleted: "hide", StartDate: "month-picker", EndDate: "month-picker", Mon: "editable", Tue: "editable", Wed: "editable", Thu: "editable", Fri: "editable", Sat: "editable", Sun: "editable" };
    var _rascheck = true;
    if (userDetails) {
        if (userDetails.UserContext.isNewScheduler === "1" || userDetails.UserContext.isCalendarScheduler === "1")
            _rascheck = true;
        else
            _rascheck = false;
    }
    let _usernavigation = [{ val: "User Details", ref: "User Details", show: true },
    { val: "User Preferences", ref: "User Preferences", show: true },
    { val: "Resource Availability", ref: "Resource Availability (RAS/CAL Only)", show: _rascheck },
    { val: "Reports Rights", ref: "Reports", show: true },
    { val: "Outsourcing Rights", ref: "Outsource", show: true },
    { val: "Utilities Rights", ref: "Utility Access", show: true },
    { val: "System Access Rights", ref: "System Access", show: true },
    { val: "Task Rights", ref: "Task", show: true },
    { val: "Integration Rights", ref: "Integration", show: true },
    { val: "RAS Scheduler Rights", ref: "RAS Scheduler", show: (userDetails ? userDetails.UserContext.isRAS === "1" ? true : false : false) },
    { val: "Legacy CAL Scheduler Rights", ref: "Legacy CAL Scheduler", show: (userDetails ? userDetails.UserContext.isCalendarScheduler === "1" ? true : false : false) },
    { val: "CAL Scheduler Rights", ref: "CAL Scheduler", show: (userDetails ? userDetails.UserContext.isNewScheduler === "1" ? true : false : false) },

        // {val:"Insights Rights",ref:"InsightsForm"}, 
        //{val:"Location Access User Group",ref:"Location Access User Rights"}
    ];

    const FIRM_ID = userDetails ? userDetails.UserContext.firmId : 1245;
    const LOGIN_USER_ID = userDetails ? userDetails.UserContext.userId : 1
    const FIRM_SERVICE_TYPE_ID = userDetails ? userDetails.UserContext.firmTypeId : 1
    const FirmEnableSSO = userDetails && userDetails.UserContext.FirmEnableSSO ? userDetails.UserContext.FirmEnableSSO : "N";
    const RAS_MUTUAL_ID = [36, 49, 43, 37];
    const CALENDER_MUTUAL_ID = [56, 57];
    const LEGACY_CAL_MUTUAL_ID = [48, 46, 45, 44];

    let _return_match_obj = (_obj) => {
        return (_match_obj[_obj]) ? _match_obj[_obj] : "";
    }

    let _dateformat = (_date) => {
        let _dd = new Date(_date);
        let _month = _dd.getMonth();
        //_month=_month.toString().length==1?"0"+_month.toString():_month;
        //let _final=_month+"/"+_dd.getDate();
        let _final = _dd.getDate() + " " + _month_text[_month];
        return _dd;
    }
    let _checkmutualrights = (_id) => {
        if (RAS_MUTUAL_ID.includes(_id)) return RAS_MUTUAL_ID;
        if (CALENDER_MUTUAL_ID.includes(_id)) return CALENDER_MUTUAL_ID;
        if (LEGACY_CAL_MUTUAL_ID.includes(_id)) return LEGACY_CAL_MUTUAL_ID;
        return [];
    }
    let UserProfile = (_obj) => {
        try {
            let checkLockCompletetask;
            let _res = Object.keys(_obj).reduce((_group, _item) => (_group[_item] = []), {});
            if (_obj.FirmSettingList.length) {
                checkLockCompletetask = _obj.FirmSettingList[0].lockCompletedTasks;
            }
            Object.keys(_obj).map((_mainobj) => {
                if (_mainobj == 'ActiveUsersCount' || _mainobj == 'LicenseCount' || _mainobj == 'FirmLinkage') {
                    return;
                }
                if (_mainobj != "moduleMaster") {      //Array                      
                    _res[_mainobj] = _obj[_mainobj].map((x) => {
                        let _key = Object.keys(x);
                        let _klength = _key.length;
                        if (_klength)
                            return { key: x[_key[_klength - 2]], text: x[_key[_klength - 1]], value: x[_key[_klength - 1]] }
                        else return { key: [], text: [], value: [] }
                    });
                }
                else {//object
                    // var _rightdetails=Object.values(_obj.ConstantModulemaster);             
                    var _rightdetails = _obj[_mainobj].map(x => {
                        var _tempgrp = _obj.GroupRights.filter(xx => xx.user_rights_id === parseInt(x.module_id)).map(y => {
                            return _obj.rightsGroupNames.filter(yy => {
                                if (yy.Group_id == y.Group_id) return yy.Group_name
                            });
                        });
                        let _showmodule = true;
                        let _showrights = true;
                        let _shw = _usernavigation.filter(xx => xx.ref === x.RightCategory);
                        if (_shw.length > 0)
                            _showmodule = _shw[0].show;

                        var _temp = [];
                        _tempgrp.forEach(aa => {
                            aa.forEach(bb => {
                                var _o = new Object();
                                _o.Group_Name = bb.Group_name;
                                _o.GroupShow = false;
                                _temp.push(_o);
                                return _o;
                            });
                        });

                        if (x.module_id === 52) {  //hide Access to new XCM                           
                            _showrights = false;
                        }
                        if (x.module_id === 31) {
                            (checkLockCompletetask === "N") ? _showrights = false : _showrights = true;
                        }


                        var _o = new Object();
                        _o.ModuleID = x.module_id;
                        _o.Access = (x.module_id === 52) ? "Y" : "N";//assign Y to access to new XCM as default
                        _o.UpdatedBy = LOGIN_USER_ID;
                        //_o.GroupShow=false;
                        _o.Category = x.RightCategory;
                        _o.Permission = x.module_name;
                        _o.ShowModule = _showmodule;
                        _o.ShowRights = _showrights;
                        _o.Mutual = _checkmutualrights(x.module_id);
                        _o.Disabled = false;
                        _o.Grouplist = _temp;
                        //_o.Grouplist=[];
                        _o.Description = x.RightDescription;
                        return _o;

                    })
                    var _valarray = [];
                    _rightdetails.map(x => {
                        if (_valarray.indexOf(x.Category) === -1)
                            _valarray.push(x.Category);
                    });
                    _res[_mainobj] = _valarray.map(x => {
                        var _group = _rightdetails.map(xx => {
                            if (xx.Category === x) {
                                return xx;
                            }
                        });
                        return _group.filter(y => { if (y) return y })
                    });
                }
            });
            localStorage.removeItem("RASinfo");
            let _mycalenderindex = -1;
            // let _collaborateindex=-1;
            _res.pageDetails.map((x, i) => {
                if (x.key === 21)
                    _mycalenderindex = i;
                //  if(x.key === 5)
                //  _collaborateindex=i;
            });
            // if(_mycalenderindex!==-1)
            //   _res.pageDetails.splice(_mycalenderindex,1);
            // if(_collaborateindex!==-1)
            // _res.pageDetails.splice(_collaborateindex,1);
            _res.FirmCalSettings = _obj.FirmCalSettings;
            _res.moduleMaster.map(xx => xx.sort((a, b) => (a.Permission > b.Permission) ? 1 : -1));
            _res["generation_type"] = [{ key: 1, text: "I", value: "I" }, { key: 2, text: "II", value: "II" }, { key: 3, text: "III", value: "III" }, { key: 4, text: "IV", value: "IV" }, { key: 5, text: "Jr", value: "Jr" }, { key: 6, text: "Sr", value: "Sr" }, { key: 7, text: "MD", value: "MD" }];
            _res["YearsOfExp"] = [{ key: 1, text: "1", value: "1" }, { key: 2, text: "2", value: "2" }, { key: 3, text: "3", value: "3" }, { key: 4, text: "4", value: "4" }, { key: 5, text: "5", value: "5" }, { key: 6, text: "6", value: "6" }, { key: 7, text: "7", value: "7" }];
            _res["ShowRAS"] = _usernavigation.filter(xx => xx.val === "Resource Availability")[0].show;
            return _res;
        }
        catch (e) {
            console.log("LoopUpUtilities-->UserProfile", e);
        }
    }

    let LoadUserProfile = (_state, _user) => {
        //console.log(_user);
        if (_user.user_details.user_id) {
            _state.error_signal.value = false;
            _state.defaultCat.defaultCategory = _user.user_details['DefaultCategory'] == null ? 0 : _user.user_details['DefaultCategory']
            Object.keys(_state).map((x) => {
                if (_state[x].type == "text" || _state[x].type == "radio") {
                    /*if(x==="wrk_exp_begindate")
                        _state[x].value=moment(_user.user_details[x]).format('MM / DD / YY');         
                   else   */
                    if (x === "YearsOfExp")
                        _user.user_details[x] = (typeof _user.user_details[x] === "object") ? "" : _user.user_details[x];
                    _state[x].value = _user.user_details[x];
                    _state[x].error = false;
                }
                else if (_state[x].type == "password" || _state[x].type == "confirmpassword") {
                    _state[x].value = "***************";
                    _state[x].error = false;
                    _state[x].show = (FirmEnableSSO === "N") ? true : false;
                    if (_state[x].type === "confirmpassword") {
                        _state[x].value = "";
                        _state[x].show = false;
                    }

                }
                else if (_state[x].type == "select") {
                    let _res;
                    if (typeof _user.user_details[x] === "string")
                        _res = (_user.profile_lookup[_return_match_obj(x)]) ? [...new Set(_user.user_details[x].split(","))].map(yy => { return _user.profile_lookup[_return_match_obj(x)].filter(xx => xx.key === parseInt(yy)) }) : ""
                    else
                        _res = (_user.profile_lookup[_return_match_obj(x)]) ? _user.profile_lookup[_return_match_obj(x)].filter(xx => xx.key == _user.user_details[x]) : ""

                    if (_res.length) {
                        if (typeof _state[x].value === "object") {
                            _res = _res.filter(zz => { if (typeof zz === "object" && zz.length) { return zz; } });
                            _state[x].value = _res.reduce(function (ac, cc) { return ac.concat(cc[0].text) }, []);
                        }
                        else {
                            _state[x].value = _res.reduce(function (ac, cc) { return ac + ((cc.length) ? cc[0].text : (cc.text) ? cc.text : "") }, "");
                        }
                    }
                    if (x === "generation_type") {
                        var isFound = _user.profile_lookup.generationList.find(g => g.value === _user.user_details.generation_type);
                        if (isFound === undefined) {
                            _user.profile_lookup.generation_type.push({ key: _user.profile_lookup.generationList.length, text: _user.user_details.generation_type, value: _user.user_details.generation_type });
                        }
                        _state[x].value = _user.user_details[x];
                    }
                    _state[x].error = false;
                }
                else if (_state[x].type == "ip_field") {
                    _user.user_details[x] = (typeof _user.user_details[x] === "object") ? "" : _user.user_details[x];
                    _state[x].value = _user.user_details[x].split(",").map(xx => {
                        let _sub = xx.split("-");
                        if (_sub.length == 1)
                            return { from: _sub[0], to: "" }
                        else {
                            let _to = _sub[0].split(".");
                            _to[3] = _sub[1];
                            return { from: _sub[0], to: _to.join(".") }
                        }
                    })
                    _state[x].error = false;
                }
                else if (_state[x].type == "componentras") {
                    var _result = _user.user_details._ResourceAvailability.map(x => {
                        return Object.keys(x).map(xx => {
                            if (Object.keys(_rasobjecttype).includes(xx)) {
                                let _value;
                                if (_rasobjecttype[xx] == "month-picker")
                                    _value = _dateformat(x[xx]);
                                else if (_rasobjecttype[xx] == "editable")
                                    _value = x[xx] + "h";
                                else
                                    _value = x[xx];
                                return { name: xx, type: _rasobjecttype[xx], value: _value }
                            }
                        });
                    });
                    _result = _result.map(xx => {
                        return xx.filter(x => {
                            if (typeof (x) === "object") return x
                        });
                    });
                    _result = _result.map(x => {
                        var total = x.reduce((cc, xx) => { return cc + (xx.type === "editable" ? parseInt(xx.value, 10) : 0) }, 0)
                        let obj = { name: "Total", type: "noneditable", value: total.toString() }
                        x.push(obj);
                        return x
                    });
                    _state[x].value = _result;
                }
                else if (_state[x].type == "componentrights") {
                    if (_user.profile_lookup.moduleMaster[0][0]["Grouplist"]) {
                        _state.UserRights.value = _user.profile_lookup.moduleMaster;
                    }
                    if (_state.UserRights.value) {
                        // console.log(_user.user_details._userRights);               
                        _user.user_details._userRights.forEach(zz => {
                            _state.UserRights.value.map(x => {
                                return x.map(y => {
                                    if (parseInt(y.ModuleID, 10) === parseInt(zz.module_id, 10)) {
                                        y.Access = zz.access;
                                        if(y.Mutual.length && y.Access==="Y"){
                                        y.Mutual.map(mu => {
                                            let _cc = x.filter(
                                              ca => ca.ModuleID === (mu !== parseInt(zz.module_id, 10)  ? mu : -1)
                                            );
                                            if (_cc.length) _cc[0].Access = "N";
                                          });
                                        }
                                        y.Disabled = false;
                                        if (y.Grouplist.length) {
                                            y.Grouplist.map(wz => {
                                                wz.GroupShow = false;
                                            });
                                            _state.belongsto_group.value.map(aa => {
                                                var _bb = y.Grouplist.filter(v => v.Group_Name === aa)
                                                if (_bb.length) { _bb[0].GroupShow = true; y.Disabled = true; }
                                            });
                                        }
                                        // _state.belongsto_group.value.includes(y.Grouplist[0])? y.GroupShow=true:y.GroupShow=false; 

                                    }
                                });
                            });
                        });
                    }
                }
            });
        }
        return _state;
    }

    let BuildUserProfile = (_obj, _lookup) => {
        //console.log("Object and lookup", _obj, _lookup)
        try {
            let _finalobj = {};
            Object.keys(_obj).map((x) => {
                _finalobj[x] = _obj[x].value
            });
            //Add new branch_name for a request API
            _finalobj.branch_name = "";
            let _singleSelect = [
                { lookup: "firmBranches", finalobj: "branch_id" },
                { lookup: "rolesDetails", finalobj: "primary_role" },
                { lookup: "rolesDetails", finalobj: "secondary_role" },
                { lookup: "titleLevelList", finalobj: "title_level" },
                { lookup: "pageDetails", finalobj: "LandingPageId" },
                { lookup: "generation_type", finalobj: "generation_type" },
                { lookup: "YearsOfExp", finalobj: "YearsOfExp" }
            ];

            //console.log("_singleSelect", _singleSelect)
            let _multiSelect = [
                { lookup: "department", finalobj: "department" },
                { lookup: "industry", finalobj: "industry_group" },
                { lookup: "expertise", finalobj: "expertise" },
                { lookup: "nicheGroups", finalobj: "niche_group" },
                { lookup: "rightsGroupNames", finalobj: "belongsto_group" },
                { lookup: "pageDetails", finalobj: "page_id" },
                { lookup: "firmBranches", finalobj: "task_locations" }
            ];

            _multiSelect.map((xx) => {
                let _temp = [];
                if (_obj[xx.finalobj].value.length > 0)
                    _obj[xx.finalobj].value.forEach((yy) => {
                        _lookup[xx.lookup].forEach((x) => {
                            if (x.value === yy) {
                                _temp.push(x.key)
                            }
                        })
                    })
                _finalobj[xx.finalobj] = _temp.join(",");
            });
            _singleSelect.map((xx) => {
                if (_obj[xx.finalobj].value != "undefined") {
                    _lookup[xx.lookup].forEach((x) => {
                        if (x.value === _obj[xx.finalobj].value) {
                            if (xx.finalobj === "branch_id") {
                                _finalobj[xx.finalobj] = x.key;
                                _finalobj["branch_name"] = x.value;
                            }
                            else {
                                _finalobj[xx.finalobj] = (xx.finalobj != "generation_type") ? x.key : x.value;
                            }
                        }
                    });
                } else _finalobj[xx.finalobj] = "";
            });

            let _RASfinal = _finalobj.ResourceAvailabilities.map((xx) => {
                return new RAS(xx);
            });
            var i = _RASfinal.length
            while (i--) {
                if (_RASfinal[i].ID == 0 && _RASfinal[i].Deleted == "Y")
                    _RASfinal.splice(i, 1);
            }
            _finalobj.ResourceAvailabilities = _RASfinal;
            var _userrights = [];
            _obj.UserRights.value.map(x => {
                return x.filter(y => {
                    delete y.Category;
                    delete y.Grouplist;
                    delete y.Description;
                    delete y.Permission;
                    delete y.Disabled;
                    delete y.Mutual;
                    delete y.GroupShow;
                    delete y.ShowModule;
                    delete y.ShowRights;
                    _userrights.push(y);
                });
            });
            if (Number.isInteger(_finalobj["LandingPageId"])) {
                let _m = _finalobj["LandingPageId"].toString();
                if (_finalobj["page_id"].length) {
                    let _p = _finalobj["page_id"].split(",");
                    let _i = _p.indexOf(_m)
                    if (_i != -1) {
                        _p.sort(function (x, y) { return x == _m ? -1 : y == _m ? 1 : 0; });
                    }
                    else {
                        _p.unshift(_m);
                    }
                    _finalobj["page_id"] = _p.join(",");
                }
                else
                    _finalobj["page_id"] = _m;
            }
            [RAS_MUTUAL_ID, CALENDER_MUTUAL_ID, LEGACY_CAL_MUTUAL_ID].map(vv => {
                var _rascheck = [];
                vv.map((aa, _ia) => {
                    let _r = _userrights.filter(bb => bb.ModuleID === aa);
                    if (_r.length)
                        if (_r[0].Access === "Y")
                            _rascheck.push(_r[0]);
                });
                if (_rascheck.length >= 2) {
                    _rascheck.map(cc => {
                        cc.Priority = vv.indexOf(cc.ModuleID);
                    });
                    _rascheck.map(ww => {
                        if (ww.Priority !== Math.min.apply(Math, _rascheck.map(o => o.Priority)))
                            ww.Access = "N"
                    });
                }
            });

            _finalobj.UserRights = _userrights.sort((a, b) => (a.ModuleID > b.ModuleID) ? 1 : -1);
            _finalobj["IP_from"] = _finalobj["IP_from"].map(x => { if (x.from.length) { if (!x.to) return x.from; else { return x.from + "-" + x.to.split(".")[3] } } }).filter(x => x !== undefined).join(",");
            _finalobj["firm_id"] = FIRM_ID;
            _finalobj["FirmEnableSSO"] = FirmEnableSSO;
            _finalobj["UpdatedBy"] = LOGIN_USER_ID;
            _finalobj["servicetype_id"] = FIRM_SERVICE_TYPE_ID;
            _finalobj["defaultCategory"] = _obj.defaultCat.defaultCategory;
            if (_finalobj["wrk_exp_begindate"] === "")
                _finalobj["wrk_exp_begindate"] = new Date("1900");
            if (_finalobj["page_id"] === "")
                _finalobj["page_id"] = "1";
            if (_finalobj["secondarybilling_rate"] === "")
                _finalobj["secondarybilling_rate"] = 0;
            if (_finalobj["primarybilling_rate"] === "")
                _finalobj["primarybilling_rate"] = 0;
            if (_finalobj["confirmpassword"].length > 0)
                _finalobj["login_password"] = _finalobj["confirmpassword"];
            delete _finalobj["confirmpassword"];
            delete _finalobj["password"];
            return _finalobj;
        }
        catch (e) {
            console.log("LoopUpUtilities-->BuildUserProfile", e);
        }
    }
    return {
        UserProfileLookup: UserProfile,
        UserInsertObject: BuildUserProfile,
        LoadUserProfileDate: LoadUserProfile,
        ProfileNavigation: _usernavigation
    }

})();

export default LoopUpUtilities;